export const baseURL = "https://rikaab.com/Api";
// export const baseURL = "http://10.111.10.67:5001/Api";  
//
